function thumbSliderObj() {
  return {
    spaceBetween: 30,
    slidesPerView: 3,
    freeMode: true,
    direction: 'vertical',
    breakpoints: {
      0: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      767: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      991: {
        spaceBetween: 20,
        slidesPerView: 3,
      },
      1200: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
    },
  };
}
function mainSliderObj(thumb) {
  return {
    spaceBetween: 20,
    speed: 800,
    loop: true,
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    pagination: {
      el: '.s-home-slider-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: thumb,
    },
  };
}
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  // document.querySelectorAll(".add-to-cart-button-products").forEach((btn) => {
  //   btn.addEventListener("click", function (event) {
  //     event.preventDefault();
  //     console.log("click");
  //   });
  // });
  if (document.querySelector('.js-toggle')) {
    document.querySelector('.js-toggle').addEventListener('click', function (e) {
      e.preventDefault();
      this.classList.toggle('active');
      document.querySelector('.s-header-menu').classList.toggle('active');
    });
  }
  if (document.querySelector('.s-home-slider-main')) {
    if (document.querySelector('.s-home-slider-main')) {
      let block1 = document.querySelector('.s-home-block.block1');
      let sliders = block1.children;

      for (var i = 0; i < sliders.length; i++) {
        var sliderThumb = new Swiper('.s-home-slider-thumb.slider' + (i + 1), thumbSliderObj());
        var sliderMain = new Swiper('.s-home-slider-main.slider' + (i + 1), mainSliderObj(sliderThumb));
      }
    }
  }
  if (document.querySelector('.js-reviewsslider')) {
    var swiperReviews = new Swiper('.js-reviewsslider', {
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 800,
      loop: false,
      autoHeight: true,
      pagination: {
        el: '.js-pagerreviews',
        clickable: true,
      },
      navigation: {
        nextEl: '.s-reviews-arrow.right',
        prevEl: '.s-reviews-arrow.left',
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        560: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        561: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        767: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        992: {
          spaceBetween: 30,
          slidesPerView: 'auto',
        },
      },
    });
  }

  if (document.querySelector('.inpproduct')) {
    NiceSelect.bind(document.querySelector('.inpproduct'));
  }

  var wow = new WOW({
    boxClass: 'wow', // animated element css class (default is wow)
    animateClass: 'animate__animated', // animation css class (default is animated)
    offset: 0, // distance to the element when triggering the animation (default is 0)
    mobile: false, // trigger animations on mobile devices (default is true)
    live: false, // act on asynchronously loaded content (default is true)
    callback: function (box) {
      // the callback is fired every time an animation is started
      // the argument that is passed in is the DOM node being animated
    },
    scrollContainer: null, // optional scroll container selector, otherwise use window,
    resetAnimation: false, // reset animation on end (default is true)
  });
  wow.init();

  let activefaqheader = document.querySelectorAll('.s-faq-item.active');
  for (let ah of activefaqheader) {
    let parent1 = ah;
    let article1 = ah.querySelector('.s-faq-item-title').nextElementSibling;
    parent1.classList.add('active');
    article1.style.maxHeight = article1.scrollHeight + 20 + 20 + 'px';
    article1.style.paddingTop = 20 + 'px';
    article1.style.paddingBottom = 20 + 'px';
  }
  if (document.querySelector('.js-map')) {
    initMap();
  }
  // if(document.querySelectorAll("form")){
  //   document.querySelectorAll("form").forEach(function (form) {
  //     form.addEventListener("submit", function (event) {
  //       event.preventDefault();
  //       let checkValid = validatInputs(event.target);

  //       if(checkValid){

  //      }
  //    }, true);
  //   });
  // }
  // Fast checkout button setup
  if (document.querySelector('#fast-checkout')) {
    const fastCheckoutBtn = document.querySelector('#fast-checkout');

    fastCheckoutBtn.addEventListener('click', function () {
      // TO DO: THE VARIANTIONS FAST CHECKOUT
      const productVariantId = document.querySelector('#id option:checked').value;
      const quantity = document.querySelector('input[name="quantity"]').value;
      // console.log("Fast checkout was clicked");
      // console.log(productVariantId);
      // console.log(quantity);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: productVariantId,
          quantity: quantity || 1,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          window.location.href = '/checkout';
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  }

  if (document.querySelector('.js-toggle')) {
    document.querySelector('.js-toggle').addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('.s-menu').classList.toggle('active');
      this.classList.toggle('active');
      document.querySelector('.s-header').classList.toggle('fix');
    });
  }
  if (document.querySelector('.js-search')) {
    document.querySelector('.js-search').addEventListener('click', function (e) {
      e.preventDefault();
      this.closest('.s-header-search').classList.toggle('active');
    });
  }
  if (document.querySelectorAll('.s-header-filter-title')) {
    document.querySelectorAll('.s-header-filter-title').forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        if (this.closest('.s-header-filter').classList.contains('active')) {
          this.closest('.s-header-filter').classList.remove('active');
        } else {
          document.querySelectorAll('.s-header-filter').forEach((item) => {
            item.classList.remove('active');
          });
          this.closest('.s-header-filter').classList.add('active');
        }
      });
    });
  }

  let faqheaders = document.querySelectorAll('.s-faq-item');

  for (let fh of faqheaders) {
    fh.addEventListener('click', openCurrAccordion1);
  }
  function openCurrAccordion1() {
    for (let fh of faqheaders) {
      let parent = fh;
      let article = fh.querySelector('.s-faq-item-title').nextElementSibling;
      if (this === fh && !parent.classList.contains('active')) {
        parent.classList.add('active');
        article.style.maxHeight = article.scrollHeight + 20 + 20 + 'px';
        article.style.paddingBottom = 20 + 'px';
        article.style.paddingTop = 20 + 'px';
      } else {
        parent.classList.remove('active');
        article.style.maxHeight = '0px';
        article.style.paddingBottom = '0px';
        article.style.paddingTop = '0px';
      }
    }
  }
});

function increaseCount(a, b) {
  var input = b.previousElementSibling;
  var value = parseInt(input.value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  input.value = value;
}

function decreaseCount(a, b) {
  var input = b.nextElementSibling;
  var value = parseInt(input.value, 10);
  if (value > 1) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
  }
}

let headersC = document.querySelectorAll('.s-home-more-item');

if (headersC) {
  for (let h of headersC) {
    h.addEventListener('click', openCurrAccordion);
  }
  function openCurrAccordion() {
    for (let h of headersC) {
      let parent = h;
      let article = h.querySelector('.s-home-more-item-title').nextElementSibling;
      if (this === h && !parent.classList.contains('active')) {
        parent.classList.add('active');
        article.style.maxHeight = article.scrollHeight + 24 + 'px';
        article.style.paddingBottom = 24 + 'px';
      } else {
        parent.classList.remove('active');
        article.style.maxHeight = '0px';
        article.style.paddingBottom = '0px';
      }
    }
  }
}

function fadeOut(el) {
  el.style.opacity = 1;

  (function fade() {
    if ((el.style.opacity -= 0.1) < 0) {
      el.style.display = 'none';
    } else {
      setTimeout(fade, 40);
    }
  })();
}

// fade in

function fadeIn(el) {
  el.style.opacity = 0;
  el.style.display = 'block';

  (function fade() {
    var val = parseFloat(el.style.opacity);
    if (!((val += 0.1) > 1)) {
      el.style.opacity = val;
      requestAnimationFrame(fade);
    }
  })();
}

/* IIFE end */

// breakpoint where swiper will be destroyed
// and switches to a dual-column layout
const breakpoint = window.matchMedia('(min-width:992px)');

// keep track of swiper instances to destroy later
let mySwiper, mySwiper1;

//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////

const breakpointChecker = function () {
  // if larger viewport and multi-row layout needed
  if (breakpoint.matches === true) {
    // clean up old instances and inline styles when available
    if (mySwiper !== undefined) {
      if (mySwiper) {
        mySwiper.destroy();
      }
    }
    if (mySwiper1 !== undefined) {
      if (mySwiper1) {
        mySwiper1.destroy();
      }
    }

    // or/and do nothing
    return;

    // else if a small viewport and single column layout needed
  } else if (breakpoint.matches === false) {
    // fire small viewport version of swiper
    return enableSwiper();
  }
};

//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////

const enableSwiper = function () {
  if (document.querySelector('.js-optionsslider')) {
    mySwiper2 = new Swiper('.js-optionsslider', {
      spaceBetween: 25,
      slidesPerView: 'auto',
      speed: 800,
      loop: false,
    });
  }
  if (document.querySelector('.js-benefitsslider')) {
    mySwiper = new Swiper('.js-benefitsslider', {
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 800,
      loop: false,
      autoHeight: true,
      pagination: {
        el: '.js-pagerbenefits',
        clickable: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        560: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        561: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        767: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
      },
    });
  }
  if (document.querySelector('.js-productsslider')) {
    mySwiper1 = new Swiper('.js-productsslider', {
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 800,
      loop: false,
      autoHeight: true,
      pagination: {
        el: '.js-pagerproducts',
        clickable: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        560: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        561: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        767: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
      },
    });
  }
};

//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////

// keep an eye on viewport size changes
breakpoint.addListener(breakpointChecker);

// kickstart
breakpointChecker();

function initMap() {
  const myLatLng = { lat: 40.368843649308495, lng: -74.0845768169006 };

  const map = new google.maps.Map(document.getElementById('map1'), {
    zoom: 16,
    center: myLatLng,
    disableDefaultUI: true,
  });

  const marker = new google.maps.Marker({
    position: myLatLng,
    map: map,

    title: '',
    icon: 'https://cdn.shopify.com/s/files/1/0788/3338/5811/files/marker.png?v=1704811444',
  });

  google.maps.event.addListener(marker, 'click', function () {
    infowindow.open(map, marker);
  });

  marker.setMap(map);
}

function validatInputs(formName) {
  let form = formName;
  var inputs = form.querySelectorAll('.validate');
  var checkboxCheck = false;
  var fileCheck = false;
  var valid = [];
  inputs.forEach(function (i, j) {
    if (i.getAttribute('type')) {
      var checkAttr = i.getAttribute('type');
    } else {
      var checkAttr = i.tagName;
    }

    switch (checkAttr) {
      case 'text':
        var _thisVal = i.value;
        if (_thisVal === '') {
          i.closest('.p-contacts-form-item').classList.add('error');
          valid.push(i.getAttribute('name'));
        } else {
          i.closest('.p-contacts-form-item').classList.remove('error');
        }
        break;
      case 'tel':
        var _thisVal = i.value;
        var regPhone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        if (_thisVal === '') {
          i.closest('.p-contacts-form-item').classList.add('error');
          valid.push(i.getAttribute('name'));
        } else {
          if (regPhone.test(i.value)) {
            i.closest('.p-contacts-form-item').classList.remove('error');
          } else {
            i.closest('.p-contacts-form-item').classList.add('error');
            valid.push(i.getAttribute('name'));
          }
        }
        break;
      case 'email':
        var regEmail = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
        if (i.value === '') {
          i.closest('.p-contacts-form-item').classList.add('error');
          valid.push(i.getAttribute('name'));
        } else {
          if (regEmail.test(i.value)) {
            i.closest('.p-contacts-form-item').classList.remove('error');
          } else {
            i.closest('.p-contacts-form-item').classList.add('error');
            valid.push(i.getAttribute('name'));
          }
        }
        break;
      default:
        if (i.value === '') {
          i.closest('.p-contacts-form-item').classList.add('error');
          valid.push(i.getAttribute('name'));
        } else {
          i.closest('.p-contacts-form-item').classList.remove('error');
        }
        break;
    }
  });

  if (valid.length > 0) {
    // console.log(valid.length);
    return false;
  } else {
    return true;
  }
}
